(function () {
	'use strict';

	window.addEventListener
		? window.addEventListener('load', initMap, false)
		: window.attachEvent && window.attachEvent('onload', initMap);

	function initMap() {
		const contactMap = document.getElementById('contact-map');
		if (!contactMap) return;

		let isMobile = false;
		const theme_path = '/wp-content/themes/qpr/';

		/* mapbox settings */
		let map;
		let markers;
		let markerW = 20;
		let markerH = 20;
		let mapCenter = [-98, 37]; /* Kansas, Center of U.S.A. */
		let bounds;
		let maxBounds;
		let offsetH, offsetV;

		/* Create a popup, but don't add it to the map yet */
		let popup = new mapboxgl.Popup({
			closeButton: false,
			closeOnClick: false,
			offset: {
				bottom: [0, -16],
			},
		});

		fetchLocations();
		scaleMap();

		window.addEventListener(
			'resize',
			function (event) {
				clearTimeout(window.resizedFinished);
				window.resizedFinished = setTimeout(function () {
					scaleMap();
				}, 200);
			},
			true
		);

		function fetchLocations() {
			/* Call the fetch function passing the url of the API as a parameter */
			const url = `${theme_path}lib/wp-map-locations.json`;
			fetch(url)
				.then((response) => response.json())
				.then(function (response) {
					markers = response;
					createMap();
				})
				.catch(function () {
					console.log('map locations error');
				});
		}

		function createMap() {
			bounds = new mapboxgl.LngLatBounds();
			mapboxgl.accessToken =
				'pk.eyJ1IjoidXBoZWF2YWxkZXNpZ24iLCJhIjoiY2ppM3JhajBvMDFqdDNwcW9ucGo5aWg3NCJ9.1sBN-K_oFK8ghjkHV667Rw';
			map = new mapboxgl.Map({
				container: 'contact-map',
				//style: 'mapbox://styles/mapbox/dark-v9'
				style: 'mapbox://styles/upheavaldesign/cji3wx1jt202k2sn7b8efwu3n',
				/* for clearing tiles cache */
				//style: 'mapbox://styles/upheavaldesign/cji3wx1jt202k2sn7b8efwu3n?fresh=true',

				zoom: 2.75,
				//minZoom: 2.75,
				maxZoom: 15,
				center: mapCenter,
			});

			addMarkers();

			map.on('load', function () {
				if (isMobile) {
					/* if mobile zoom to Los Angeles */
					setTimeout(function () {
						map.easeTo(
							{
								center: mapCenter,
								zoom: 7,
								duration: '3000',
							},
							{
								callback: 'endEaseTo',
							}
						);
					}, 500);
				} else {
					/*call function with delay to allow map to populate first*/
					setTimeout(function () {
						map.fitBounds(
							bounds,
							{
								//maxZoom: 4.5,
								//linear: true,
								//padding: 60,
								padding: 120,
							},
							{
								callback: 'endFitBounds',
							}
						);
					}, 500);
				}
			});

			map.on('moveend', function (e) {
				const DOMmarkers = contactMap.querySelectorAll('.marker');
				if (e.callback == 'endFitBounds') {
					//map.setMaxBounds(maxBounds);
					/* MinZoom can force markers to be displaced */
					//map.setMinZoom(3.5);

					DOMmarkers.forEach((marker, i) => {
						setTimeout(function () {
							marker.classList.add('reveal');
						}, (i + 1) * 260);
					});
				} else if (e.callback == 'endEaseTo') {
					DOMmarkers.forEach((marker) => {
						marker.classList.add('reveal');
					});
				} else {
					return;
				}
			});
		}

		function addMarkers() {
			/* add markers to map */
			markers.features.forEach(function (marker) {
				/* create a DOM element for the marker */
				let el = document.createElement('div');
				el.className = 'marker';
				//el.style.backgroundImage = 'url(' + theme_path + 'images/svg/icons/marker.svg)';
				el.style.width = markerW + 'px';
				el.style.height = markerH + 'px';

				/* add marker to map */
				new mapboxgl.Marker(el).setLngLat(marker.geometry.coordinates).addTo(map).setOffset([offsetH, offsetV]);

				bounds.extend(marker.geometry.coordinates);

				if (marker.properties.headquarters) {
					//console.log('headquarters', marker.properties.title);
					el.classList.add('hq');
				}

				if (marker.properties.url != '') {
					el.addEventListener('click', function () {
						window.open(marker.properties.url, '_blank');
					});
				}

				el.addEventListener('mouseenter', function (e) {
					/* Change the cursor style as a UI indicator */
					map.getCanvas().style.cursor = 'pointer';

					let label = `<span class="label">${marker.properties.title}</span>`;
					if (marker.properties.address) label += `<p>${marker.properties.address}</p>`;

					/* Populate the popup and set its coordinates
				based on the feature found */
					popup.setLngLat(marker.geometry.coordinates).setHTML(label).addTo(map);
				});

				el.addEventListener('mouseleave', function () {
					map.getCanvas().style.cursor = '';
					popup.remove();
				});
			});

			let southWest = bounds.getSouthWest(),
				northEast = bounds.getNorthEast(),
				swLat = parseFloat(southWest.lat) - 18,
				swLng = parseFloat(southWest.lng) - 40,
				newSW = new mapboxgl.LngLat(swLng, swLat);

			let neLat = parseFloat(northEast.lat) + 12,
				neLng = parseFloat(northEast.lng) + 40,
				newNE = new mapboxgl.LngLat(neLng, neLat);

			maxBounds = new mapboxgl.LngLatBounds(newSW, newNE);
			//boundsCenter = bounds.getCenter();
		}

		function scaleMap() {
			var sW = document.documentElement.clientWidth;
			var sH = document.documentElement.clientHeight;

			if (sW < 767) {
				isMobile = true;
				/* for mobile view, center map on marker  */
				mapCenter = [-118.2481906, 34.0518321]; /* Primary location */
				// markerW = 50;
				// markerH = 50;

				/* for mobile view, size map height to viewport  */
				contactMap.style.height = sH - 320;
				contactMap.style.minHeight = 220;
			} else {
				contactMap.style.height = '';
			}

			// offsetH = -Math.abs(parseInt(markerW * 0.3333));
			// offsetV = -Math.abs(parseInt(markerH * 0.5));
			offsetH = 0;
			offsetV = 0;
		}
	}
})();
